import { Box, Radio, TextField, Typography } from "@mui/material";
import { useState } from "react";
import AppButton from "../common/AppButton";
import CardPaymentIcon from "../IconComp/cardPaymentIcon";
import EasyPaisaIcon from "../IconComp/easyPaisaIcon";
import JazzCashIcon from "../IconComp/jazzCashIcon";
import BankTransferIcon from "../IconComp/bankTransfer";
import GreenTickIcon from "../IconComp/greenTickIcon";
import InClinicCashIcon from "../IconComp/inClinicCashIcon";
import { InclinicPaymentType } from "../../utils/constants";
import AppModal from "../common/AppModal";
import { InvoiceModal } from "./invoice-model";
import cashIcon from "../../assets/icons/cashIcon.svg";
import visaCreditCardIcon from "../../assets/icons/visaCreditCardIcon.svg";

export const PaymentModal = ({
  selectedInstructions,
  setSelectedEnumValue,
  paidAmount,
  handlePaidAmountChange,
  errorMessage,
  hasDiscountPercentagePrevious,
  previousDiscountRemainingAmount,
  remainingAmount,
  handleGenerateInvoiceAndSubmit,
  openModal,
  handleClose,
  invoiceId,
  handleCloseModal,
  handleSaveAndClose,
  setSelectedPayment,
  selectedPayment,
  totalSingleMedDiscountPayable,
  totalPayable,
  handleCloseEditFunction,
}: any) => {
  //   const [selectedPayment, setSelectedPayment] = useState("");

  // Function to handle selecting a payment option

  const handlePaymentSelect = (method: any) => {
    // Map payment methods to the corresponding enum value
    switch (method) {
      case "Card Payment":
        setSelectedEnumValue(InclinicPaymentType.BankCard);
        break;
      case "Easy Paisa":
        setSelectedEnumValue(InclinicPaymentType.EasyPaisa);
        break;
      case "Jazz Cash":
        setSelectedEnumValue(InclinicPaymentType.JazzCash);
        break;
      case "Bank Transfer":
        setSelectedEnumValue(InclinicPaymentType.BankTransfer);
        break;
      case "Cash":
        setSelectedEnumValue(InclinicPaymentType.Cash);
        break;
      case "Other":
        setSelectedEnumValue(InclinicPaymentType.Other);
        break;
      default:
        setSelectedEnumValue(InclinicPaymentType.Other); // Default case
    }

    setSelectedPayment(method);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          gap: 1.5,
          padding: 1,
          // width: "100%",
          // maxWidth: "438px",
          margin: "0 auto",
        }}
      >
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: "500",
            display: "flex",
            flexDirection: "row",
            color: "#2C323D",
          }}
        >
          Select Payment Method
          {/* Total Payable :
          {hasDiscountPercentagePrevious
            ? totalSingleMedDiscountPayable.toFixed(2)
            : totalPayable.toFixed(2)} */}
        </Box>
        {/* Card Payment Option */}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "left",
            flexWrap: {
              xs: "wrap",
              sm: "nowrap",
            }
            
          }}
        >
          {/* Card Payment Option */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "40%",
              // padding: "8px",
              // border: "1px solid #C4C4C4",
              // borderRadius: "10px",
              cursor: "pointer",
              borderColor:
                selectedPayment === "Card Payment" ? "#0055A8" : "#C4C4C4", // Change based on selected payment
              //   backgroundColor:
              //     selectedPayment === "Card Payment" ? "#e3f2fd" : "transparent", // Change based on selection
              transition: "all 0.3s ease",
            }}
            onClick={() => handlePaymentSelect("Card Payment")}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pr: "10px",
              }}
            >
              <Radio
                checked={selectedPayment === "Card Payment"}
                value="Card Payment"
                sx={{ p: 0, pr: 1 }}
              />
              <img src={visaCreditCardIcon} alt="Credit Card" />
              {/* <CardPaymentIcon /> */}
            </Box>
            {/* <Box ...>Card Payment</Box> */}
          </Box>

          {/* Easy Paisa Option */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "40%",
              // padding: "12px",
              // border: "1px solid #C4C4C4",
              // borderRadius: "10px",
              cursor: "pointer",
              borderColor:
                selectedPayment === "Easy Paisa" ? "#0055A8" : "#C4C4C4", // Change based on selected payment
              transition: "all 0.3s ease",
            }}
            onClick={() => handlePaymentSelect("Easy Paisa")}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pl: "5px",
                pr: "42px",
              }}
            >
              <Radio
                checked={selectedPayment === "Easy Paisa"}
                value="Easy Paisa"
                sx={{ p: 0, pr: 1 }}
              />
              <EasyPaisaIcon />
            </Box>
            {/* <Box ...>Easy Paisa</Box> */}
          </Box>

          {/* Jazz Cash Option */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "40%",
              // padding: "12px",
              // border: "1px solid #C4C4C4",
              // borderRadius: "10px",
              cursor: "pointer",
              borderColor:
                selectedPayment === "Jazz Cash" ? "#0055A8" : "#C4C4C4", // Change based on selected payment
              transition: "all 0.3s ease",
            }}
            onClick={() => handlePaymentSelect("Jazz Cash")}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pr: "15px",
              }}
            >
              <Radio
                checked={selectedPayment === "Jazz Cash"}
                value="Jazz Cash"
                sx={{ p: 0, pr: 1 }}
              />
              <JazzCashIcon />
            </Box>
            {/* <Box ...>Jazz Cash</Box> */}
          </Box>

          {/* Bank Transfer Option */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "40%",
              padding: "12px",
              // border: "1px solid #C4C4C4",
              // borderRadius: "10px",
              cursor: "pointer",
              borderColor:
                selectedPayment === "Bank Transfer" ? "#0055A8" : "#C4C4C4", // Change based on selected payment
              transition: "all 0.3s ease",
            }}
            onClick={() => handlePaymentSelect("Bank Transfer")}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pl: "5px",
                pr: "38px",
              }}
            >
              <Radio
                checked={selectedPayment === "Bank Transfer"}
                value="Bank Transfer"
                sx={{ p: 0, pr: 1 }}
              />
              <BankTransferIcon />
            </Box>
            {/* <Box ...>Bank Transfer</Box> */}
          </Box>

          {/* Cash Option */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // justifyContent: "space-between",
              width: "100%",
              // padding: "12px",
              // border: "1px solid #C4C4C4",
              // borderRadius: "10px",
              cursor: "pointer",
              borderColor: selectedPayment === "Cash" ? "#0055A8" : "#C4C4C4", // Change based on selected payment
              transition: "all 0.3s ease",
            }}
            onClick={() => handlePaymentSelect("Cash")}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pl: "3px",
                pr: "31px",
              }}
            >
              <Radio
                checked={selectedPayment === "Cash"}
                value="Cash"
                sx={{ p: 0, pr: 1 }}
              />
              <img src={cashIcon} alt="Cash Icon" />
              {/* <InClinicCashIcon /> */}
            </Box>
            {/* <Box ...>Cash</Box> */}
          </Box>

          {/* Your other commented-out code and logic remains untouched */}
        </Box>
      </Box>
      <AppModal
        title="Invoice Details"
        open={openModal}
        handleClose={handleClose}
        fullScreen={false}
        maxWidth="sm"
        //maxWidth="md"
        // maxWidth={"10%"}
      >
        <InvoiceModal
          invoiceId={invoiceId}
          selectedInstructions={selectedInstructions}
          onClose={handleCloseModal}
          onSaveAndClose={handleSaveAndClose}
          handleCloseEditFunction={handleCloseEditFunction}
        />
      </AppModal>
    </>
  );
};
